module.exports = __webpack_public_path__ + "static/media/avatar-placeholder.2ef2d879.svg";